function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
},
/*#__PURE__*/
React.createElement("rect", {
  stroke: "#D3D3D3",
  fill: "#3498D8",
  x: 0.5,
  y: 0.5,
  width: 35,
  height: 23,
  rx: 4
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M8.048 12.3h1.719l-.86-2-.859 2zM32 8.5h-4.404l-1.074 1.1-.966-1.1H16.21l-.86 1.8-.858-1.8h-3.76v.8l-.43-.8H7.082l-3.114 7h3.759l.43-1.1H9.23l.43 1.1h4.188v-.8l.322.8h2.149l.322-.9v.9h8.592l1.074-1.1.967 1.1h4.404L28.885 12 32 8.5zm-12.996 6h-1.182v-3.9l-1.826 3.9h-1.074l-1.826-3.9v3.9h-2.47l-.43-1.1H7.62l-.43 1.1H5.793l2.255-5h1.826l2.04 4.7V9.5h2.042l1.61 3.4 1.504-3.4h2.041v5h-.107zm10.633 0h-1.611l-1.396-1.7-1.611 1.7h-4.834v-5h4.94l1.505 1.6 1.61-1.6h1.504L27.381 12l2.256 2.5zm-8.27-4v.9h2.685v1h-2.685v1h3.007l1.396-1.5-1.289-1.4h-3.114z",
  fill: "#FFF"
}));

var SvgAmExCard = function SvgAmExCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      viewBox: "0 0 36 24",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgAmExCard, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/AmExCard.8a349bb2.svg";
export { ForwardRef as ReactComponent };